import { resolver } from "@msuite/ui/libs/form";
import { useTranslation } from "@msuite/ui/localization";
import { Modal, type ModalProps } from "@msuite/ui/modal";
import { responseHandler } from "@msuite/ui/utils";
import { type TeamFormSchema, teamFormSchema } from "@msuite/utils/schemas";
import { FormProvider, useForm } from "react-hook-form";
import { TeamForm } from "@/forms/team-form";
import { client } from "@/hono";

/** Props Interface */
interface AddTeamModalProps extends ModalProps {
	onComplete?: () => Promise<void>;
}

export function AddTeamModal({ onClose, isOpen, onComplete }: AddTeamModalProps) {
	/** Hooks */
	const { t } = useTranslation();
	const methods = useForm({
		resolver: resolver(teamFormSchema),
	});

	/** Functions */
	async function handleOnSubmit(json: TeamFormSchema) {
		const response = await client.organizations.team.$post({
			json,
		});
		await responseHandler(response);
		await onComplete?.();
		onClose();
	}

	/** Render */
	return (
		<FormProvider {...methods}>
			<Modal
				title={t("organization.add_team")}
				isOpen={isOpen}
				onClose={onClose}
				onSubmit={methods.handleSubmit(handleOnSubmit, (error) => {
					console.info(error);
				})}
			>
				<Modal.Body>
					<TeamForm />
				</Modal.Body>
				<Modal.FooterForm />
			</Modal>
		</FormProvider>
	);
}
